export const HYPERSCENE_DEMO_ROUTE: string = '/hyperscene';
export const HYPERSCENE_PACKAGE_NAME: string = '@sibe/hyperscene';
export const HYPERSCENE_PACKAGE_FEATURE_ENABLED: boolean = true;
